<template>
    <div id="app">
        <transition :name="'transitionRouterLeft'" mode="out-in">
            <router-view class="routerView" />
        </transition>
    </div>
</template>

<script>
export default {
    name: "App",
    data() {
        return {
            transitionName: "transitionRouterLeft",
        };
    },
    components: {},
    watch: {
        $route(to, from) {
            this.transitionName =
                this.transitionName === "transitionRouterLeft"
                    ? "transitionRouterRight"
                    : "transitionRouterLeft";
        },
    },
};
</script>

<style lang="less">
@import "./common/css/index.less";
.routerView{
    max-width: 880px;
    margin: 0 auto;
    background-color: #fff;
}
</style>

<style lang="less" scoped>
@import "./common/css/main.less";
@import "./common/css/transition.less";
</style>




// WEBPACK FOOTER //
// src/App.vue